module.exports = __webpack_public_path__ + "static/media/lb.23f85946.svg";